import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import 'moment/locale/pt-br';
import DateFnsUtils from '@date-io/date-fns';
import ptBrLocale from 'date-fns/locale/pt-BR';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { instanceAxios } from '../../InstanceAxios';
import { formatMoney } from '../../utils/common';
import HeadTable from '../../components/HeadTable';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import IconButton from '@material-ui/core/IconButton';
import FilterIcon from '@material-ui/icons/FilterList';

function DescontoIndicacao() {
  const useStyles = makeStyles((theme) => ({
    root: {
      height: '',
      overflow: 'auto',
      width: '95%',
    },
    paper: {
      position: 'absolute',
      width: 800,
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      top: `50%`,
      left: `50%`,
      transform: `translate(-50%, -50%)`,
      width: '80%',
      height: '80%',
      overflow: 'auto',
    },
    loading: {
      marginLeft: '50%',
    },
  }));

  const [columns, setColumns] = useState([
    { id: 'nome', label: 'Usuário', minWidth: 150, filterable: true },
    { id: 'cupom', label: 'Cupom', minWidth: 50, filterable: true },
    { id: 'valor', label: 'Valor', minWidth: 50, filterable: true },
    {
      id: `"HistoricoUsoCupom"."created_at"`,
      label: 'Data Utilização',
      minWidth: 150,
      filterable: true,
    },
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const [filterText, setFilterText] = useState('');
  const [columnId, setColumnId] = useState('');
  const [originalCupons, setOriginalCupons] = useState([]);
  const [openAlert, setOpenAlert] = useState(false);
  const [tipoAlert, setTipoAlert] = useState('');
  const [messageAlert, setMessageAlert] = useState('');
  const [ready, setReady] = useState(true);
  const [cupons, setCupons] = useState([]);
  const [cupom, setCupom] = useState({ id: '' });
  const [dtInicial, setDtInicial] = useState(
    moment('2020-01-01').format('YYYY-MM-DD HH:ss')
  );
  const [dtFinal, setDtFinal] = useState(moment().format('YYYY-MM-DD HH:ss'));
  const [historico, setHistorico] = useState([]);
  const [count, setCount] = useState(0);
  const [qtdPorPagina, setQtdPorPagina] = useState(10);
  const [page, setPage] = useState(0);
  const [campoOrdenacao, setCampoOrdenacao] = useState('');
  const [ordem, setOrdem] = useState('');
  const [idOrder, setIdOrder] = useState('');
  const [order, setOrder] = useState('asc');

  useEffect(() => {
    const fetchCupons = async () => {
      await instanceAxios(localStorage.getItem('toobiauth'))
        .get(`/cupom`)
        .then((res) => {
          setCupons(res.data.rows);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    fetchCupons();
    atualizarHistorico('', '', '', '', '', '', '');
  }, []);

  const clickAlert = () => {
    setOpenAlert(false);
    setTipoAlert('');
    setMessageAlert('');
  };

  const handleDataIncial = async (data) => {
    const dt = moment(data).format('YYYY-MM-DD HH:ss');
    setDtInicial(dt);
    atualizarHistorico(
      cupom.id,
      dt,
      dtFinal,
      page,
      qtdPorPagina,
      campoOrdenacao,
      ordem
    );
  };

  const handleDataFinal = async (data) => {
    const dt = moment(data).format('YYYY-MM-DD HH:ss');
    setDtFinal(dt);
    atualizarHistorico(
      cupom.id,
      dtInicial,
      dt,
      page,
      qtdPorPagina,
      campoOrdenacao,
      ordem
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    atualizarHistorico(
      cupom.id,
      dtInicial,
      dtFinal,
      newPage,
      qtdPorPagina,
      campoOrdenacao,
      ordem
    );
  };

  const handleChangeRowsPerPage = (event) => {
    setQtdPorPagina(event.target.value);
    setPage(0);
    atualizarHistorico(
      cupom.id,
      dtInicial,
      dtFinal,
      0,
      event.target.value,
      campoOrdenacao,
      ordem
    );
  };

  const atualizarHistorico = async (id, dtIni, dtFnl, pg, qpg, co, o) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(
        `/historicocupom?idCupom=${id}&dtInicio=${dtIni}&dtFim=${dtFnl}&limit=${qpg}&page=${pg}&campoOrdenacao=${co}&ordem=${o}`
      )
      .then((res) => {
        setCount(res.data.count);
        setHistorico(res.data.rows);
        setOriginalCupons(res.data.rows);
        setReady(true);
      })
      .catch((err) => {
        console.log(err);
        setHistorico([]);
        setReady(true);
      });
  };

  const handleCampoOrdenacao = (co) => {
    let o;
    // Checando se é o mesmo atual
    if (co === campoOrdenacao) {
      o = ordem === 'asc' ? 'desc' : 'asc';
      setOrdem(o);
    } else {
      o = 'asc';
      setOrdem(o);
      setCampoOrdenacao(co);
    }
    atualizarHistorico(cupom.id, dtInicial, dtFinal, page, qtdPorPagina, co, o);
  };

  const openModal = (event, columnid) => {
    setFilterText('');
    const rect = event.target.getBoundingClientRect();
    setIsModalOpen(true);
    setModalPosition({ top: rect.top, left: rect.left });
    setColumnId(columnid);
  };

  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };

  // Function to filter the table data
  const filterTable = () => {
    setIsModalOpen(false);
    console.log(originalCupons);
    console.log(columnId);
    const filteredDas = originalCupons.filter((item) => {
      if (columnId == 'nome') {
        const value = item.User[columnId];
        return (
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase())
        );
      } else {
        const value = item.CupomDeDesconto[columnId];
        return (
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase())
        );
      }
    });
    console.log(filteredDas);
    // Update the table data with filtered data
    setHistorico(filteredDas);
  };

  const clearFilter = () => {
    setIsModalOpen(false);
    setFilterText('');
    setHistorico(originalCupons);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleRequestSort = (property) => {
    const orderBy = property;
    let orderAux = order;
    if (idOrder === property && orderAux === 'desc') {
      orderAux = 'asc';
    } else {
      orderAux = 'desc';
    }
    setOrder(orderAux);
    setIdOrder(orderBy);
  };

  const sortTable = (property) => {
    const isAsc = order === 'asc';
    historico.sort((a, b) => {
      let aValue;
      let bValue;
      if (property == 'nome') {
        aValue = a.User[property];
        bValue = b.User[property];
      } else {
        aValue = a.CupomDeDesconto[property];
        bValue = b.CupomDeDesconto[property];
      }
      // If the property is a string, convert to lowercase for case-insensitive sorting
      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }
      if (aValue < bValue) {
        return isAsc ? -1 : 1;
      }
      if (aValue > bValue) {
        return isAsc ? 1 : -1;
      }
      return 0;
    });
    setHistorico(historico);
  };

  const classes = useStyles();
  return (
    <>
      <Modal
        open={isModalOpen}
        onClose={closeModal}
        style={{ top: modalPosition.top, left: modalPosition.left }}
      >
        <div
          style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '5px',
            width: '300px',
          }}
        >
          <TextField
            label="Filtrar"
            variant="outlined"
            value={filterText}
            onChange={handleFilterTextChange}
            fullWidth
          />
          <Button
            variant="contained"
            color="primary"
            onClick={filterTable}
            style={{ marginTop: '10px' }}
          >
            Filtrar
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={clearFilter}
            style={{ marginTop: '10px', marginLeft: '5px', width: 70 }}
          >
            Limpar
          </Button>
        </div>
      </Modal>
      <div align="center">
        <h1>Cupons de Desconto</h1>
      </div>
      <Collapse in={openAlert}>
        <Alert severity={tipoAlert} onClick={clickAlert}>
          {messageAlert}
        </Alert>
      </Collapse>
      <Paper className={classes.root}>
        <Collapse in={ready === false}>
          <CircularProgress className={classes.loading} />
        </Collapse>
        <Collapse in={ready}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              padding: 10,
            }}
          >
            <Grid container>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Autocomplete
                  id="autoCompleteCupom"
                  options={cupons}
                  getOptionLabel={(option) => option.cupom}
                  groupBy={(option) => option.tipo_utilizacao}
                  onChange={(event, value) => {
                    const c = value || { id: '' };
                    setCupom(c);
                    atualizarHistorico(
                      c.id,
                      dtInicial,
                      dtFinal,
                      page,
                      qtdPorPagina,
                      campoOrdenacao,
                      ordem
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      style={{ width: 200 }}
                      label="Cupom"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div align="right">
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={ptBrLocale}
                  >
                    <Grid container justify="space-around">
                      <KeyboardDatePicker
                        margin="normal"
                        id="picker-inicio"
                        label="Data Inicial"
                        format="dd/MM/yyyy"
                        value={dtInicial}
                        onChange={handleDataIncial}
                        KeyboardButtonProps={{
                          'aria-label': 'Mudar Data Inicial',
                        }}
                      />
                      <KeyboardDatePicker
                        margin="normal"
                        id="picker-final"
                        label="Data Final"
                        format="dd/MM/yyyy"
                        value={dtFinal}
                        onChange={handleDataFinal}
                        KeyboardButtonProps={{
                          'aria-label': 'Mudar Data Final',
                        }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </div>
              </Grid>
            </Grid>
          </div>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <TableSortLabel
                        active={idOrder === column.id}
                        direction={idOrder === column.id ? order : 'asc'}
                        onClick={() => {
                          handleRequestSort(column.id);
                          setTimeout(() => {
                            sortTable(column.id);
                          }, 200);
                        }}
                      >
                        {column.label}
                      </TableSortLabel>

                      {column.filterable && (
                        <IconButton
                          style={{ marginLeft: -5 }}
                          onClick={(event) => openModal(event, column.id)}
                          aria-label="filtra"
                        >
                          <FilterIcon style={{ width: 16, height: 16 }} />
                        </IconButton>
                      )}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {historico.map((h) => {
                return (
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {h.User ? h.User.nome : ''}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {h.CupomDeDesconto ? h.CupomDeDesconto.cupom : ''}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {formatMoney(
                        h.CupomDeDesconto ? h.CupomDeDesconto.valor / 100 : 0
                      )}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {moment(h.createdAt).format('DD/MM/YYYY hh:mm')}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <TableFooter>
            <TableRow>
              <TablePagination
                component="div"
                style={{ backgroundColor: '#FFF' }}
                rowsPerPageOptions={[5, 10, 25]}
                count={count}
                rowsPerPage={qtdPorPagina}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage="Linhas por página"
              />
            </TableRow>
          </TableFooter>
        </Collapse>
      </Paper>
    </>
  );
}

export default DescontoIndicacao;
